import { all, call, fork, put, takeLatest } from "redux-saga/effects";
import { getApplicantsFromCareerBuilder, getApplicantsFromInternalDB, getApplicantsFromMonster, getMonsterResumesImport, getCareerBuilderResumesImport } from "./internalDbESApi.js";
import {
    getAllApplicantsDataStart, getAllApplicantsDataSuccess, getAllApplicantsDataFailure, getCareerBuilderApplicantsDataStart, getCareerBuilderApplicantsDataSuccess, getCareerBuilderApplicantsDataFailure, getIntegratedSearchStart, getMonsterApplicantsDataStart, getMonsterApplicantsDataFailure, getMonsterApplicantsDataSuccess, updateCareerBuilderApplicantsDataStart, updateCareerBuilderApplicantsDataSuccess, updateCareerBuilderApplicantsDataFailure, updateMonsterApplicantsDataStart, updateMonsterApplicantsDataSuccess, updateMonsterApplicantsDataFailure, fetchBulkResumesDataStart,
    fetchBulkResumesSuccess,
    fetchBulkResumesFailure,
    fetchCBBulkResumesDataStart,
    fetchCBBulkResumesSuccess,
    fetchCBBulkResumesFailure,
    setcareerBuilderAccessidStart,
    setcareerBuilderAccessidSuccess,
    setcareerBuilderAccessidFailure,
    setMonsterAccessidStart,
    setMonsterAccessidSuccess,
    setMonsterAccessidFailure,
    setAllApplicantAccessidStart,
    setAllApplicantAccessidSuccess,
    setAllApplicantAccessidFailure,
    addApplicantToInternalDB,
    revertStateLoading
} from "./internalDbESlice.js";
import { showToast } from "../../../components/index.js";
import { getAllIntegrationAccess } from "../setting/settingApi.js";
import { useSelector } from "react-redux";
import { formatWords2 } from "../../../utils/stringUtils.js";

function* getAllApplicantsData(params) {
    const actionValue = params.payload.action || params.payload

    try {
        const response = yield call(getApplicantsFromInternalDB, actionValue);
        if (response?.data?.field?.data?.totalRecords === 0) {
            showToast("No search results found.", "error");
        }
        if (response) {
            yield put(getAllApplicantsDataSuccess(response.data || {}));
            params?.payload?.onSuccess && params?.payload?.onSuccess();
        }
    } catch (error) {
        yield put(getAllApplicantsDataFailure([]));
        // alert(error)
        console.error("Internal DB fetch error:", error);
    } finally {
        yield put(revertStateLoading());
    }
}

function* getAllApplicantsCareerBuilder(params) {
    try {
        // console.log("career classic params", params);
        const response = yield call(getApplicantsFromCareerBuilder, params.payload);
        if (response) {
            const result = yield call(parseCareerBuilderResponse, response?.data?.data?.response?.careerBuilderResponse, response?.data?.data?.response?.existingCandidates);
            const existingCandidates = response?.data?.data?.response?.existingCandidates;
            yield put(getCareerBuilderApplicantsDataSuccess({ result, existingCandidates }));

            if (response?.error) {
                showToast(response?.error, "error");
            } else if (result?.total === 0) {
                yield call(params.payload.onSuccess);
                showToast("No search results found.", "error");
            }

            if (result?.tableResponse?.length > 0 && typeof params.payload.onSuccess === "function" && params?.payload?.onSuccess) {
                yield call(params.payload.onSuccess);
            }

            //showToast("Candidates Searched Successflly.")
        }
    } catch (error) {
        yield put(getCareerBuilderApplicantsDataFailure([]));
        // alert(error)
        //showToast("Candidates Search Failed", "error")
        console.error("Internal DB fetch error:", error);
    } finally {
        yield put(revertStateLoading());
    }
}
const formatNewCandidateForInternalDB = (candidate, source) => {
  if (!candidate) return null;

  return {
    uiid: candidate.uiid,
    firstName: candidate.firstName || "",
    lastName: candidate.lastName || "",
    jobTitle: candidate.jobTitle || "N/A",
    email: {
      primary: {
        email:
          candidate?.email?.primary?.email ??
          candidate?.email?.primary ??
          "-",
      },
    },
    mobile: {
      primary: {
        number: candidate?.mobile?.primary?.number ?? null,
      },
    },
      location: {
          city: candidate?.location?.city || "N/A",
          state:
              typeof candidate?.location?.state === "string"
                  ? candidate.location.state
                  : candidate?.location?.state?.code || "N/A",
          zipCode: candidate?.location?.zipCode || "N/A",
      },
    exp: {
      year: candidate?.exp?.year ?? 0,
      mon: candidate?.exp?.mon ?? 0,
    },
    workAuth: candidate?.workAuth || "N/A",
    salaryInfo: {
      payRate: {
        currency: candidate?.salaryInfo?.payRate?.currency ?? "N/A",
      },
    },
    source,
    addedBy: {
      firstName: formatWords2(candidate?.addedBy?.firstName) || "-",
    },

    addedOn: candidate?.addedOn || new Date().toISOString(),
    modifiedOn: candidate?.modifiedOn || new Date().toISOString(),

    notes: candidate?.notes || [],
  };
};


function* updateAllApplicantsCareerBuilder(params) {
    try {
        const { existing, newCandidate, tableResponse, fullResponse, existingCandidates } = params.payload;

        const { updatedTableResponse, updatedFullResponse, updatedExistingCandidates } = yield call(formatCareerBuilerPullResult, existing, newCandidate, tableResponse, fullResponse, existingCandidates);
        yield put(updateCareerBuilderApplicantsDataSuccess({ updatedTableResponse, updatedFullResponse, updatedExistingCandidates }));
        const formattedCandidate = formatNewCandidateForInternalDB(
            params.payload.newCandidate,
            2
        );
     
        if (formattedCandidate) {
            yield put(addApplicantToInternalDB(formattedCandidate));
        }
    } catch (error) {
        yield put(updateCareerBuilderApplicantsDataFailure());
    } finally {
        yield put(revertStateLoading());
    }
}


function* getAllApplicantsMonster(params) {
    try {
        const response = yield call(getApplicantsFromMonster, params.payload);
        if (response) {
            const existingCandidates = response?.data?.data?.response?.existingCandidates;
            const result = yield call(parseXMLMonsterClassicSearch, response?.data?.data?.response?.monsterResponse, existingCandidates);
            yield put(getMonsterApplicantsDataSuccess({ result, existingCandidates }));
            if (result?.total === 0) {
                yield call(params.payload.onSuccess);
                showToast("No search results found.", "error");
            }

            if (result?.tableResponse?.length > 0 && typeof params.payload.onSuccess === "function" && params?.payload?.onSuccess) {
                yield call(params.payload.onSuccess);

            }
        }
    } catch (error) {
        yield put(getMonsterApplicantsDataFailure([]));
        console.error("Internal DB fetch error:", error);
        showToast("Failed to fetch data from Monster.", "error");
    } finally {
        yield put(revertStateLoading());
    }
}

function* updateAllApplicantsMonster(params) {
    try {
        const { existing, newCandidate, tableResponse, fullResponse, existingCandidates } = params.payload;

        const { updatedTableResponse, updatedFullResponse, updatedExistingCandidates } = yield call(formatCareerBuilerPullResult, existing, newCandidate, tableResponse, fullResponse, existingCandidates);
        yield put(updateMonsterApplicantsDataSuccess({ updatedTableResponse, updatedFullResponse, updatedExistingCandidates }));
        const formattedCandidate = formatNewCandidateForInternalDB(
            params.payload.newCandidate,
            3
        );
        if (formattedCandidate) {
            yield put(addApplicantToInternalDB(formattedCandidate));
        }
    } catch (error) {
        yield put(updateMonsterApplicantsDataFailure());
    } finally {
        yield put(revertStateLoading());
    }
}

// function* getIntegratedSearchData(params) {
//     try {
//         console.log("Integrated Search Params:", params);
//         const [internalDB, careerBuilder, monster] = yield all([
//             call(getApplicantsFromInternalDB, params.payload.internalDB),
//             call(getApplicantsFromCareerBuilder, params.payload.careerBuilder),
//             call(getApplicantsFromMonster, params.payload.monster),
//         ]);
//         console.log("Integrated Search Results:", { internalDB, careerBuilder, monster });
//         if (internalDB.success || careerBuilder.success || monster.success) {
//             // Set Internal DB
//             yield put(getAllApplicantsDataSuccess(internalDB.data || {}));

//             // Set Career Builder
//             const resultCB = yield call(parseCareerBuilderResponse, careerBuilder?.data?.data?.response?.careerBuilderResponse);
//             const existingCandidatesCB = careerBuilder?.data?.data?.response?.existingCandidates;
//             yield put(getCareerBuilderApplicantsDataSuccess({ result: resultCB, existingCandidates: existingCandidatesCB }));

//             // Set Monster
//             const resultM = yield call(parseXMLMonsterClassicSearch, monster?.data?.data?.response?.monsterResponse);
//             const existingCandidatesM = monster?.data?.data?.response?.existingCandidates;
//             yield put(getMonsterApplicantsDataSuccess({ result: resultM, existingCandidates: existingCandidatesM }));

//             // Success and Show Toast
//             params?.payload?.onSuccess && params?.payload?.onSuccess();
//         }

//     } catch (error) {
//         console.log(error)
//         yield put(getAllApplicantsDataFailure([]));
//         yield put(getCareerBuilderApplicantsDataFailure([]));
//         yield put(getMonsterApplicantsDataFailure([]));
//     } finally {
//         yield put(revertStateLoading());
//     }
// }
function* getIntegratedSearchData(params) {
    try {
        console.log("Integrated Search Params:", params);
        yield fork(function* () {
            try {
                const internalDB = yield call(
                    getApplicantsFromInternalDB,
                    params.payload.internalDB
                );

                if (internalDB?.success) {
                    yield put(
                        getAllApplicantsDataSuccess(
                            internalDB.data || {}
                        )
                    );
                } else {
                    yield put(getAllApplicantsDataFailure([]));
                }
            } catch (error) {
                console.log("InternalDB Error:", error);
                yield put(getAllApplicantsDataFailure([]));
            }
        });

        /* ===============================
           CAREER BUILDER
        =============================== */
        yield fork(function* () {
            try {
                const careerBuilder = yield call(
                    getApplicantsFromCareerBuilder,
                    params.payload.careerBuilder
                );

                if (careerBuilder?.success) {
                    const resultCB = yield call(
                        parseCareerBuilderResponse,
                        careerBuilder?.data?.data?.response?.careerBuilderResponse
                    );

                    const existingCandidatesCB =
                        careerBuilder?.data?.data?.response?.existingCandidates;

                    yield put(
                        getCareerBuilderApplicantsDataSuccess({
                            result: resultCB,
                            existingCandidates: existingCandidatesCB
                        })
                    );
                } else {
                    yield put(getCareerBuilderApplicantsDataFailure([]));
                }
            } catch (error) {
                console.log("CareerBuilder Error:", error);
                yield put(getCareerBuilderApplicantsDataFailure([]));
            }
        });

        /* ===============================
           MONSTER
        =============================== */
        yield fork(function* () {
            try {
                const monster = yield call(
                    getApplicantsFromMonster,
                    params.payload.monster
                );

                if (monster?.success) {
                    const resultM = yield call(
                        parseXMLMonsterClassicSearch,
                        monster?.data?.data?.response?.monsterResponse
                    );

                    const existingCandidatesM =
                        monster?.data?.data?.response?.existingCandidates;

                    yield put(
                        getMonsterApplicantsDataSuccess({
                            result: resultM,
                            existingCandidates: existingCandidatesM
                        })
                    );
                } else {
                    yield put(getMonsterApplicantsDataFailure([]));
                }
            } catch (error) {
                console.log("Monster Error:", error);
                yield put(getMonsterApplicantsDataFailure([]));
            }
        });

        // success callback
        params?.payload?.onSuccess?.();

    } catch (error) {
        console.log(error);
    } finally {
        yield put(revertStateLoading());
    }
}


function* fetchResumesDataWorker(action) {
    const { payload = {}, accessId } = action;
    const resolve = action.resolve || action.payload?.resolve;
    const reject = action.reject || action.payload?.reject;
    try {
        const response = yield call(getMonsterResumesImport, { accessId, ...payload });
        const resumesData = response?.data?.data || [];
        yield put(fetchBulkResumesSuccess({ data: resumesData }));
        resolve(resumesData);

    } catch (error) {
        yield put(fetchBulkResumesFailure(error.message || "saga error"));
    } finally {
        yield put(revertStateLoading());
    }
}

function* fetchCBResumesDataWorker(action) {
    const { payload = {}, accessId } = action;
    const resolve = action.resolve || action.payload?.resolve;
    const reject = action.reject || action.payload?.reject;
    try {
        const response = yield call(getCareerBuilderResumesImport, { accessId, ...payload });
        const resumesData = response?.data?.data || [];
        yield put(fetchCBBulkResumesSuccess({ data: resumesData }));
        resolve(resumesData);
    } catch (error) {
        yield put(fetchCBBulkResumesFailure(error?.message || "saga error"));
        if (typeof reject === "function") reject(error);
        console.error("saga error:", error);
    } finally {
        yield put(revertStateLoading());
    }
}

function* fetchAccessIdCareerBuilder(params) {
    try {
        const response = yield call(getAllIntegrationAccess, params.payload);
        const accessData = response?.data?.data || []
        yield put(setcareerBuilderAccessidSuccess({ data: accessData }));
    } catch (error) {
        yield put(setcareerBuilderAccessidFailure(error?.message));
    } finally {
        yield put(revertStateLoading());
    }
}
function* fetchAccessIdMonster(params) {
    try {
        const response = yield call(getAllIntegrationAccess, params.payload);
        const accessData = response?.data?.data || []
        yield put(setMonsterAccessidSuccess({ data: accessData }));
    } catch (error) {
        yield put(setMonsterAccessidFailure(error?.message));
    } finally {
        yield put(revertStateLoading());
    }
}
function* fetchAccessIdAllapplicant(params) {
    try {
        const response = yield call(getAllIntegrationAccess, params.payload);
        const accessData = response?.data?.data || []
        yield put(setAllApplicantAccessidSuccess({ data: accessData }));
    } catch (error) {
        yield put(setAllApplicantAccessidFailure(error?.message));
    } finally {
        yield put(revertStateLoading());
    }
}


export function* watchFetchApplicantsInternalDB() {
    yield takeLatest(getAllApplicantsDataStart.type, getAllApplicantsData);
    yield takeLatest(getCareerBuilderApplicantsDataStart.type, getAllApplicantsCareerBuilder);
    yield takeLatest(getMonsterApplicantsDataStart.type, getAllApplicantsMonster);
    yield takeLatest(getIntegratedSearchStart.type, getIntegratedSearchData);
    yield takeLatest(updateCareerBuilderApplicantsDataStart.type, updateAllApplicantsCareerBuilder);
    yield takeLatest(updateMonsterApplicantsDataStart.type, updateAllApplicantsMonster);
    yield takeLatest(fetchBulkResumesDataStart.type, fetchResumesDataWorker);
    yield takeLatest(fetchCBBulkResumesDataStart.type, fetchCBResumesDataWorker);
    yield takeLatest(setcareerBuilderAccessidStart.type, fetchAccessIdCareerBuilder);
    yield takeLatest(setMonsterAccessidStart.type, fetchAccessIdMonster);
    yield takeLatest(setAllApplicantAccessidStart.type, fetchAccessIdAllapplicant);
}


// Utility Function for CB XML Parsing
async function parseCareerBuilderResponse(careerBuilderResponse, existingCandidates = []) {
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(careerBuilderResponse, "application/xml");
    const total = xmlDoc.getElementsByTagName("Hits")[0]?.textContent?.trim() || "0";
    const candidates = Array.from(xmlDoc.getElementsByTagName("ResumeResultItem_V3"));

    const getText = (item, tag) =>
        item.getElementsByTagName(tag)[0]?.textContent?.trim() || "N/A";

    const tableResponse = candidates.map((item, index) => {
        const resumeId = getText(item, "ResumeID");
        const matchedCandidate = existingCandidates.find((candidate) =>
            (candidate?.resumeIds || []).some((r) => r?.id === resumeId)
        );

        return {
            index,
            // applicantId: getText(item, "UserDID"),
            applicantId: resumeId,
            name: getText(item, "ContactName"),
            jobTitle: getText(item, "ResumeTitle"),
            experience: convertMonthsToYears(getText(item, "MonthsOfExperience")),
            resumeId,
            highestEducation:
                getText(item, "DegreeLevel") !== "N/A"
                    ? getText(item, "DegreeLevel")
                    : getText(item, "HighestDegree"),
            location:
                getText(item, "Location") !== "N/A"
                    ? getText(item, "Location")
                    : getText(item, "HomeLocation"),
            source: 2,
            lastUpdate: formatDateToDDMMYYYY(
                getText(item, "ModifiedDate") !== "N/A"
                    ? getText(item, "ModifiedDate")
                    : getText(item, "LastUpdate")
            ),
            uiid: matchedCandidate?.uiid || null,
        };
    }).sort((a, b) => {
        const [da, ma, ya] = a.lastUpdate.split("/");  // dd/mm/yyyy
        const [db, mb, yb] = b.lastUpdate.split("/");

        const dateA = new Date(`${ya}-${ma}-${da}`);
        const dateB = new Date(`${yb}-${mb}-${db}`);

        return dateB - dateA; // newest first
    });

    const fullResponse = candidates.map((item, index) => {
        const resumeId = getText(item, "ResumeID");

        const matchedCandidate = existingCandidates.find((candidate) =>
            (candidate?.resumeIds || []).some((r) => r?.id === resumeId)
        );

        return {
            index,
            // applicantId: getText(item, "UserDID"),
            applicantId: resumeId,
            resumeId,
            name: getText(item, "ContactName"),
            email: getText(item, "ContactEmail"),
            emailMD5: getText(item, "ContactEmailMD5"),
            location: getText(item, "HomeLocation"),
            country: parseLocationString(getText(item, "HomeLocation")).country,
            state: parseLocationString(getText(item, "HomeLocation")).state,
            city: parseLocationString(getText(item, "HomeLocation")).city,
            lastUpdate: getText(item, "LastUpdate"),
            resumeTitle: getText(item, "ResumeTitle"),
            jobTitle: getText(item, "JobTitle"),
            recentEmployer: getText(item, "RecentEmployer"),
            recentJobTitle: getText(item, "RecentJobTitle"),
            recentPay: getText(item, "RecentPay"),
            actionType: getText(item, "ActionType"),
            highestDegree: getText(item, "HighestDegree"),
            experienceMonths: getText(item, "MonthsOfExperience"),
            experienceYearsMonths: convertMonthsToYears(getText(item, "MonthsOfExperience")),
            lastActivity: formatDateToDDMMYYYY(getText(item, "LastActivity")),
            distance: getText(item, "Distance"),
            sfnmc: getText(item, "SFNmc"),
            hasWordDoc: getText(item, "HasWordDoc"),
            source: "Career Builder",
            uiid: matchedCandidate?.uiid || null,
        };
    }).sort((a, b) => {
        const [da, ma, ya] = a.lastActivity.split("/");  // dd/mm/yyyy
        const [db, mb, yb] = b.lastActivity.split("/");

        const dateA = new Date(`${ya}-${ma}-${da}`);
        const dateB = new Date(`${yb}-${mb}-${db}`);

        return dateB - dateA; // newest first
    });

    return {
        total: Number(total),
        tableResponse,
        fullResponse,
    };
}

// Utility Funcion for Monster XML Parsing
async function parseXMLMonsterClassicSearch(xmlString, existingCandidates = []) {
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xmlString, "application/xml");

    const error = xmlDoc.querySelector("parsererror");
    if (error) throw new Error("Invalid XML: " + error.textContent);

    const resumes = Array.from(xmlDoc.getElementsByTagName("Resume"));
    const resumesElement = xmlDoc.querySelector("Resumes");
    const total = parseInt(resumesElement?.getAttribute("Found")) || 0;

    const getText = (parent, selector, defaultValue = "N/A") => {
        const el = parent.querySelector(selector);
        return el?.textContent?.trim() || defaultValue;
    };

    const getAllText = (parent, selector) => {
        return (
            Array.from(parent.querySelectorAll(selector))
                .map((el) => el.textContent.trim())
                .filter(Boolean)
                .join(", ") || "N/A"
        );
    };

    const getDateValue = (parent, selector) => {
        const el = parent.querySelector(selector);
        if (!el) return "N/A";

        // Case 1: Date is inside attribute -> FORMAT IT
        const attrDate = el.getAttribute("Date") || el.getAttribute("date");
        if (attrDate) {
            const d = new Date(attrDate);
            if (!isNaN(d.getTime())) {
                const mm = String(d.getMonth() + 1).padStart(2, "0");
                const dd = String(d.getDate()).padStart(2, "0");
                const yyyy = d.getFullYear();
                return `${mm}/${dd}/${yyyy}`; // Formatted output
            }
            return attrDate; // fallback if invalid
        }

        // Case 2: Date text inside tag -> RETURN AS IS (NO formatting)
        const textDate = el.textContent?.trim();
        return textDate || "N/A";
    };

    const getParsedDate = (parent, selector) => {
        const el = parent.querySelector(selector);
        if (!el) return null;

        const attrDate = el.getAttribute("Date") || el.getAttribute("date");
        if (!attrDate) return null;

        const d = new Date(attrDate);
        return isNaN(d.getTime()) ? null : d;
    };

    const calculateExperience = (resume) => {
        // CASE 1: <TotalYearsExperience> exists
        const totalYearsExp = resume.querySelector("TotalYearsExperience");
        if (totalYearsExp) {
            const val = parseFloat(totalYearsExp.textContent.trim());
            if (!isNaN(val)) {
                const years = Math.floor(val);
                const decimal = val - years;

                // Convert decimal directly to months (0.8 ⇒ 8 months)
                const months = Math.floor(decimal * 10);

                if (years === 0 && months === 0) return "No experience";
                if (years === 0) return `${months} month${months !== 1 ? "s" : ""}`;
                if (months === 0) return `${years} year${years !== 1 ? "s" : ""}`;
                return `${years} year${years !== 1 ? "s" : ""} ${months} month${months !== 1 ? "s" : ""}`;
            }
        }

        // CASE 2: Old experience calculation
        const experiences = Array.from(resume.querySelectorAll("Experiences > Experience"));
        if (!experiences.length) return "No experience";

        let totalMonths = 0;

        experiences.forEach((exp) => {
            const fromYear = parseInt(exp.querySelector("DateFrom")?.getAttribute("Year")) || null;
            const fromMonth = parseInt(exp.querySelector("DateFrom")?.getAttribute("Month")) || 1;
            const toYear = parseInt(exp.querySelector("DateTo")?.getAttribute("Year")) || new Date().getFullYear();
            const toMonth = parseInt(exp.querySelector("DateTo")?.getAttribute("Month")) || new Date().getMonth() + 1;

            if (fromYear && toYear) {
                const months = (toYear - fromYear) * 12 + (toMonth - fromMonth);
                totalMonths += months > 0 ? months : 0;
            }
        });

        if (totalMonths <= 0) return "No experience";

        const years = Math.floor(totalMonths / 12);
        const months = totalMonths % 12;

        if (years === 0) return `${months} month${months !== 1 ? "s" : ""}`;
        if (months === 0) return `${years} year${years !== 1 ? "s" : ""}`;
        return `${years} year${years !== 1 ? "s" : ""} ${months} month${months !== 1 ? "s" : ""}`;
    };

    const getHighestEducation = (resume) => {
        const levels = Array.from(resume.querySelectorAll("Educations > Education > Level"))
            .map((el) => el.textContent.trim())
            .filter(Boolean);
        if (!levels.length) return "N/A";
        return levels[0];
    };

    const getSkills = (resume) => {
        const skillElements = Array.from(resume.querySelectorAll("Skills > Skill"));
        return skillElements.map((skill) => ({
            name: getText(skill, "Name", "N/A"),
            yearsUsed: getText(skill, "YrsUsed", "0.0"),
        }));
    };

    const getDisplayName = (firstName, lastName) => {
        const fn = firstName?.trim();
        const ln = lastName?.trim();

        if (
            (!fn || fn === "N/A") &&
            (!ln || ln === "N/A")
        ) {
            return "Confidential";
        }

        return `${fn !== "N/A" ? fn : ""} ${ln !== "N/A" ? ln : ""}`.trim();
    };

    const formatLocation = (location = "N/A") => {
        if (!location || location === "N/A") return "N/A";

        let parts = location
            .split("-")
            .map(p => p.trim())
            .filter(Boolean);

        // Ignore country code
        if (parts[0]?.toUpperCase() === "US") {
            parts.shift();
        }

        // No state available
        if (parts.length === 0) return "N/A";

        const state = parts[0] || "N/A";
        const city = parts[1] || "N/A";

        return `${state}, ${city}`;
    };

    const tableResponse = resumes.map((resume, index) => {
        const resumeId = resume.getAttribute("SID") || "N/A";

        const matchedCandidate = existingCandidates.find((candidate) =>
            (candidate?.resumeIds || []).some((r) => r?.id === resumeId)
        );

        const firstName = getText(resume, "PersonalData > Name > First");
        const lastName = getText(resume, "PersonalData > Name > Last");
        const location = getText(resume, "PersonalData > Address > Location");
        // const location = formatLocation(rawLocation);
        const jobTitle = getText(resume, "Target > JobTitle");
        const relocation = getText(resume, "Target > Relocation");
        const jobType = getAllText(resume, "Target > JobTypes > JobType");
        const lastUpdate = getDateValue(resume, "DateModified");
        const lastUpdateDate = getParsedDate(resume, "DateModified");
        const highestEducation = getHighestEducation(resume);
        const experience = calculateExperience(resume);
        const experienceDescription = getText(resume, "Experiences > Experience > Job > Description");
        const experienceCompany = getText(resume, "Experiences > Experience > Company > Name");
        const experienceJobTitle = getText(resume, "Experiences > Experience > Job > Title");
        const source = getText(resume, "Boards > Board");
        const md5Email = getText(resume, "PersonalData > MD5-EmailAddress");
        const skills = getSkills(resume);
        const workAuthCountry = getText(resume, "WorkAuths > WorkAuth > Country");
        const workAuthType = getText(resume, "WorkAuths > WorkAuth > AuthType");
        const Relevance = getText(resume, "Relevance");
        return {
            index,
            applicantId: resumeId,
            resumeId,
            name: getDisplayName(firstName, lastName),
            md5Email,
            jobTitle,
            experience,
            experienceDescription,
            experienceCompany,
            experienceJobTitle,
            highestEducation,
            location,
            relocation,
            jobType,
            lastUpdate,
            lastUpdateDate,
            source,
            skills,
            Relevance,
            uiid: matchedCandidate?.uiid || null,
            workAuthCountry,
            workAuthType,
            workAuth: workAuthCountry && workAuthType ? `${workAuthType} ${workAuthCountry}` : "N/A",
            hasStrongSkills: Array.isArray(skills) && skills.length > 2,
        };
    }).sort((a, b) => {
    // if (!a.lastUpdateDate) return 1;
    // if (!b.lastUpdateDate) return -1;
    // return b.lastUpdateDate - a.lastUpdateDate;
    if (a.hasStrongSkills && b.hasStrongSkills) {
      return b.Relevance - a.Relevance;
    }

    if (a.hasStrongSkills !== b.hasStrongSkills) {
      return a.hasStrongSkills ? -1 : 1;
    }
    const aDate = a.lastUpdateDate ? new Date(a.lastUpdateDate).getTime() : 0;
    const bDate = b.lastUpdateDate ? new Date(b.lastUpdateDate).getTime() : 0;
    return bDate - aDate;
});

    const fullResponse = resumes.map((resume, index) => {
        const resumeId = resume.getAttribute("SID") || "N/A";

        const matchedCandidate = existingCandidates.find((candidate) =>
            (candidate?.resumeIds || []).some((r) => r?.id === resumeId)
        );

        const firstName = getText(resume, "PersonalData > Name > First");
        const lastName = getText(resume, "PersonalData > Name > Last");
        const location = getText(resume, "PersonalData > Address > Location");
        // const location = formatLocation(rawLocation);
        const country = getText(resume, "PersonalData > Address > Country");
        const state = getText(resume, "PersonalData > Address > State");
        const city = getText(resume, "PersonalData > Address > City");
        const postalCode = getText(resume, "PersonalData > Address > PostalCode");
        const md5Email = getText(resume, "PersonalData > MD5-EmailAddress");
        const jobTitle = getText(resume, "Target > JobTitle");
        const relocation = getText(resume, "Target > Relocation");
        const jobType = getAllText(resume, "Target > JobTypes > JobType");
        const lastUpdate = getDateValue(resume, "DateModified");
        const lastUpdateDate = getParsedDate(resume, "DateModified");
        const dateCreated = getText(resume, "DateCreated");
        const experienceCompany = getText(resume, "Experiences > Experience > Company > Name");
        const experienceJobTitle = getText(resume, "Experiences > Experience > Job > Title");
        const experienceDescription = getText(resume, "Experiences > Experience > Job > Description");
        const workAuthCountry = getText(resume, "WorkAuths > WorkAuth > Country");
        const workAuthType = getText(resume, "WorkAuths > WorkAuth > AuthType");
        const experience = calculateExperience(resume);
        const source = getText(resume, "Boards > Board");
        const skills = getSkills(resume);
        const Relevance = getSkills(resume,"Relevance");
        return {
            index,
            applicantId: resumeId,
            resumeId,
            firstName,
            lastName,
            name: getDisplayName(firstName, lastName),
            md5Email,
            location,
            country,
            state,
            city,
            postalCode,
            jobTitle,
            relocation,
            jobType,
            lastUpdate,
            lastUpdateDate,
            dateCreated,
            experienceCompany,
            experienceJobTitle,
            Relevance,
            experienceDescription,
            totalExperience: calculateExperience(resume),
            experience,
            highestEducation: getHighestEducation(resume),
            workAuthCountry,
            workAuthType,
            source,
            skills,
            uiid: matchedCandidate?.uiid || null,
             hasStrongSkills: Array.isArray(skills) && skills.length > 2,
        };
    }).sort((a, b) => {
    // if (!a.lastUpdateDate) return 1;
    // if (!b.lastUpdateDate) return -1;
    // return b.lastUpdateDate - a.lastUpdateDate;
     if (a.hasStrongSkills && b.hasStrongSkills) {
      return b.Relevance - a.Relevance;
    }

    if (a.hasStrongSkills !== b.hasStrongSkills) {
      return a.hasStrongSkills ? -1 : 1;
    }
    const aDate = a.lastUpdateDate ? new Date(a.lastUpdateDate).getTime() : 0;
    const bDate = b.lastUpdateDate ? new Date(b.lastUpdateDate).getTime() : 0;
    return bDate - aDate;
});

    return { total, tableResponse, fullResponse };
}


function convertMonthsToYears(months) {
    if (!months || isNaN(months)) return "0.0";
    const totalMonths = Number(months);
    const years = Math.floor(totalMonths / 12);
    const remainingMonths = totalMonths % 12;
    return `${years}.${remainingMonths}`;
}

function formatDateToDDMMYYYY(dateString) {
    if (!dateString) return "N/A";
    const dateParts = dateString.split(/[\/\-]/);
    if (dateParts.length !== 3) return "Invalid Date";
    const [year, month, day] = dateParts.map(Number);
    const dd = String(day).padStart(2, "0");
    const mm = String(month).padStart(2, "0");
    const yyyy = year;
    return `${dd}/${mm}/${yyyy}`;
}

function parseLocationString(locationStr = "") {
    if (!locationStr) return { country: "", state: "", city: "" };
    const parts = locationStr.split("-");
    return {
        country: parts[0] || "",
        state: parts[1] || "",
        city: parts.slice(2).join("-") || "",
    };
}

const formatCareerBuilerPullResult = (existing, newCandidate, tableResponse, fullResponse, existingCandidates) => {
    const updatedTableResponse = tableResponse.map(candidate => {
        if (candidate?.applicantId == existing?.applicantId) {
            return {
                ...candidate,
                uiid: newCandidate?.uiid,
                notes: newCandidate?.notes
            };
        }
        return candidate;
    });

    const updatedFullResponse = fullResponse.map(candidate => {
        if (candidate?.applicantId == existing?.applicantId) {
            return {
                ...candidate,
                uiid: newCandidate?.uiid,
                email: newCandidate?.email?.primary?.email ?? newCandidate?.email?.primary,
                jobTitle: newCandidate?.jobTitle,
                mobile: `${newCandidate?.mobile?.primary?.code}` + " " + `${newCandidate?.mobile?.primary?.number}`,
                addedBy: newCandidate?.addedBy,
                addedOn: newCandidate?.addedOn,
                resumeIds: newCandidate?.resumeIds,
                notes: newCandidate?.notes
            };
        }
        return candidate;
    });

    const updatedExistingCandidates = [
        ...existingCandidates,
        {
            _id: newCandidate?._id,
            uiid: newCandidate?.uiid,
            firstName: newCandidate?.firstName,
            lastName: newCandidate?.lastName,
            jobTitle: newCandidate?.jobTitle,
            resumeIds: newCandidate?.resumeIds,
            addedBy: newCandidate?.addedBy,
            addedOn: newCandidate?.addedOn,
            notes: newCandidate?.notes
        },
    ];


    return {
        updatedTableResponse,
        updatedFullResponse,
        updatedExistingCandidates
    };
}